module.exports = __webpack_public_path__ + "img/paytable_icon.baf6f44e.svg";